<template>
  <v-text-field
    :append-icon="appendIcon"
    :rules="rules"
    :type="passwordType"
    :id="id"
    :label="label"
    :hint="hint"
    :counter="counter"
    :color="color"
    @click:append="click"
    :outline="outline"
    :value="value"
    @input="handleChange"
    :name="name"
  >
    <slot slot="append"> </slot>

    <v-icon v-if="!this.type" slot="append" @click="passwordVisible">
      {{ passwordIcon }}
    </v-icon>
  </v-text-field>
</template>

<script>
/*
 * NOTE: To display just the input field without the password visibility
 * Set the prop type to 'password'
 */
export default {
  name: 'CSPassword',
  data() {
    return {
      showComponentPassword: false,
    }
  },
  computed: {
    passwordType() {
      if (this.passwordDisplay !== null) {
        return this.passwordDisplay ? 'text' : 'password'
      }

      return this.type || (this.showComponentPassword ? 'text' : 'password')
    },
    passwordIcon() {
      if (this.passwordDisplay !== null) {
        return this.passwordDisplay ? 'visibility' : 'visibility_off'
      }

      return this.showComponentPassword ? 'visibility' : 'visibility_off'
    },
  },
  methods: {
    passwordVisible() {
      if (this.passwordDisplay !== null) {
        this.$emit('displayPassword')
      } else {
        this.showComponentPassword = !this.showComponentPassword
      }
    },

    handleChange(val) {
      this.onChange(val)
      this.$emit('input', val)
    },
  },
  props: {
    appendIcon: {
      type: String,
      default: '',
      required: false,
    },
    rules: {
      type: Array,
      required: false,
    },
    type: {
      type: String,
      default: '',
      required: false,
    },
    value: {
      type: String,
      default: '',
      required: false,
    },
    onChange: {
      type: Function,
      required: false,
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      default() {},
    },
    id: {
      type: String,
      required: true,
      default: '',
    },
    label: {
      type: String,
      default: '',
      required: true,
    },
    hint: {
      type: String,
      default: '',
      required: false,
    },
    click: {
      type: [Function, String],
      default: '',
      required: false,
    },
    counter: {
      // type: Boolean | Number || String,
      required: false,
    },
    outline: {
      type: Boolean,
      default: true,
      required: false,
    },
    color: {
      type: String,
      default: 'slate400',
      required: false,
    },
    name: {
      type: String,
      required: false,
    },
    passwordDisplay: {
      type: Boolean,
      default: null,
    },
  },
}
</script>
